export default "__VITE_ASSET__3a2e5c42__"